import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ControllerSocketService extends Socket {
  constructor() {
    super({
      url: environment.url,
      options: {},
    });
  }

  emitEvent(event: string, data: any): void {
    this.emit(event, data);
  }

  onEvent(event: string) {
    return this.fromEvent(event);
  }
}
